export const CAMPAIGN_STATUS_LABELS: Record<string, { label: string; color: string }> = {
  PENDING: { label: 'Pendente', color: 'default' },
  PROCESSING: { label: 'Processando', color: 'processing' },
  COMPLETED: { label: 'Concluída', color: 'success' },
  COMPLETED_WITH_FAILURES: { label: 'Concluída com falhas', color: 'warning' },
  FAILED: { label: 'Falhou', color: 'error' },
};

export const RECIPIENT_STATUS_LABELS: Record<string, { label: string; color: string }> = {
  PENDING: { label: 'Pendente', color: 'default' },
  SENT: { label: 'Enviado', color: 'success' },
  FAILED: { label: 'Falhou', color: 'error' },
  SUPPRESSED_OPT_OUT: { label: 'Suprimido (opt-out)', color: 'warning' },
  SUPPRESSED_SES: { label: 'Suprimido (SES)', color: 'warning' },
};

export const CAMPAIGN_SOURCE_LABELS: Record<string, string> = {
  FILTERS: 'Filtros de cadastro',
  SURVEY: 'Participantes de pesquisa',
  JSON: 'Upload de lista (JSON)',
};
